import { useQuery } from 'react-query';
import { model, Country } from './Country';

export const countriesQueryKey = `countries`;

export const useCountries = () => useQuery<Country[]>(countriesQueryKey, () => model.getList());
